const SUPPORT = {
  INSIDER: 1,
  PEPS: 2,
  US_PAYER: 3,
  AML_CFT: 4,
  ANTISOCIAL: 5,
  ID_UPLOAD: 6,
  GOOGLE_AUTHENTICATOR: 7,
  BANK_CARD_UPLOAD: 8,
  BANK_LIST: 9,
  WITHDRAW_FEE: 10,
  BAN_COUNTRY: 11,
};

// eslint-disable-next-line import/prefer-default-export
export { SUPPORT };
